const Prodata=[
    {
    "id": 1,
    "title": "Flying Ninja",
    "price": "$12.00",
    "category": "1",
    "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2013/06/poster_2_up-300x300.jpg",
    },
    {
    "id": 2,
    "title": "Happy Ninja",
    "price": "$18.00",
    "category": "2",
    "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2013/06/T_7_front-300x300.jpg",
    },
    {
    "id": 3,
    "title": "Happy Ninja",
    "price":"$35.00",
    "category": "3",
    "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2013/06/hoodie_4_front-300x300.jpg",
    },
    {
       "id": 4,
       "title": "Ninja Silhouette",
       "price":"$20.00",
       "category": "4",
       "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2013/06/T_5_front-300x300.jpg",
    },
    {
       "id": 5,
       "title": "Ninja Silhouette",
       "price":"$35.00",
       "category": "5",
       "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2013/06/hoodie_5_front-300x300.jpg",
    },
    {
       "id": 6,
       "title": "Patient Ninja",
       "price":"$35.00",
       "category": "6",
       "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2013/06/hoodie_3_front-300x300.jpg",
    },
    {
        "id": 7,
        "title": "Premium Quality",
        "price": "$20.00",
        "category": "7",
        "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2013/06/T_2_front-300x300.jpg",
        },
        {
        "id": 8,
        "title": "Premium Quality",
        "price": "$12.00",
        "category": "8",
        "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2013/06/poster_3_up-300x300.jpg",
        },
        {
        "id": 9,
        "title": "Ship Your Idea",
        "price":"$30.00",
        "category": "9",
        "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2013/06/T_4_front-300x300.jpg",
        },
        {
           "id": 10,
           "title": "Ship Your Idea",
           "price":"$30.00-$35.00",
           "category": "10",
           "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2013/06/hoodie_7_front-300x300.jpg",
        },
        {
           "id": 11,
           "title": "Ship Your Idea",
           "price":"$15.00",
           "category": "11",
           "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2013/06/poster_1_up-300x300.jpg",
        },
        {
           "id": 12,
           "title": "Woo Album #1",
           "price":"$35.00",
           "category": "12",
           "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2013/06/cd_1_angle-300x300.jpg",
        },
]
export default Prodata;